module.exports = __webpack_public_path__ + "a1a8552a4b046817103fadcefaf34c01.MP3";